export default {
  computed: {
    item() {
      const { data, dataKey } = this;
      return data[dataKey];
    },
  },
};
